import { Component, OnInit, HostListener } from '@angular/core';
import {
  UntypedFormControl,
  Validators,
  UntypedFormGroup,
} from '@angular/forms';
import * as uuid from 'uuid';
import { StartupModel } from '../classes/model';
import { RdsServerService } from '../services/rds-server.service';
import { ImageUploadService } from '../services/image-upload.service';
// import { MatLegacySnackBar MatSnackBar } from '@angular/material/legacy-snack-bar';
// import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { SuccessPopupComponent } from '../success-popup/success-popup.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-ar-vr-form',
  templateUrl: './ar-vr-form.component.html',
  styleUrls: ['./ar-vr-form.component.scss'],
  host: {
    class: 'form',
  },
})
export class ArVrFormComponent implements OnInit {
  progressSpinner = false;
  showOptions = false;
  sUniversityCheck = false;
  sInstituteCheck = false;
  sProgramCheck = false;
  submitted = false;
  error = false;



  constructor(
    private _rdsServer: RdsServerService,
    private imageUploadService: ImageUploadService,
    private snackbar: MatSnackBar,
    private dialog: MatDialog
  ) { }
  // (startupData.value.sUniversity.Uni_Name=='Other' || startupData.value.sUniversityInput=='')

  ngOnInit(): void {
    // document.title = 'AR VR Challenge'
    console.log(this.isMobile());
    document.getElementById('one').classList.add('active');
    document.getElementById('two').classList.add('inactive');

    this._rdsServer.getUni().subscribe((res) => {
      let temp = res['meta']
      for (let i = 0; i < temp.length; i++) {
        this.university.push(temp[i])
      }
      this.university.push({
        "Uni_id": "",
        "Uni_Name": "Other",
        "Uni_Status": ""
      });
    })

    this._rdsServer.getInstitute().subscribe((res) => {
      let temp = res['meta']
      for (let i = 0; i < temp.length; i++) {
        this.institute.push(temp[i])
      }
      this.institute.push({
        "Institute_id": "",
        "Institute_Name": "Other"
      });
    })

    this._rdsServer.getProgram().subscribe((res) => {
      let temp = res['meta']
      for (let i = 0; i < temp.length; i++) {
        this.program.push(temp[i])
      }
      this.program.push({
        "Program_id": "",
        "Program_Name": "Other"
      });
    })


  }

  isMobile() {
    var check = false;
    (function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))
        check = true;
    })(navigator.userAgent || navigator.vendor);
    return check;
  };


  /* FORM GROUP */
  startupData = new UntypedFormGroup({
    sFname: new UntypedFormControl('', Validators.required),
    sLname: new UntypedFormControl('', Validators.required),
    sEmail: new UntypedFormControl('', [Validators.required, Validators.email]),
    sMobile: new UntypedFormControl('', Validators.required),
    sUniversity: new UntypedFormControl('', Validators.required),
    sUniversityInput: new UntypedFormControl(''),
    sInstitute: new UntypedFormControl('', Validators.required),
    sInstituteInput: new UntypedFormControl(''),
    sProgram: new UntypedFormControl('', Validators.required),
    sProgramInput: new UntypedFormControl(''),
    sName: new UntypedFormControl('', Validators.required),
    sProblemStatement: new UntypedFormControl('', Validators.required),
    sIdeaPitch: new UntypedFormControl('', Validators.required),
    fundOrBoot: new UntypedFormControl(true),
    statusVal: new UntypedFormControl('')
  });



  // Logo Upload
  logoBlob;
  logoExtension;
  logoKeyName;
  logoBase64: any = '../../assets/upload2.svg';
  // Pitch Deck Upload
  pitchBlob;
  pitchExtension;
  pitchKeyName;
  pitchBase64: any = '../../assets/upload2.svg';
  // '../../assets/1x/Asset 3.png'
  pitchChanged = false;
  // Arrays for drop downs
  university = [];
  institute = [];
  program = [];
  // variable to track page number
  activeSection = 1;



  firstCap(str) {
    return str[0].toUpperCase() + str.substring(1, str.length);
  }

  checkAvailableOptions(type, err) { }

  sUniversityChange() {
    var value = this.startupData.get('sUniversity').value;
    if (value.Uni_Name == "Other") {
      this.sUniversityCheck = true;
      this.startupData.get('sUniversityInput').addValidators(Validators.required);
    }
    else {
      console.log(value.Uni_id);
      this.sUniversityCheck = false;
      this.startupData.get('sUniversityInput').clearValidators();
    }

  }

  sInstituteChange() {
    var value = this.startupData.get('sInstitute').value;
    console.log(value)
    if (value.Institute_Name == "Other") {
      this.sInstituteCheck = true;
      this.startupData.get('sInstituteInput').addValidators(Validators.required);
    }
    else {
      this.sInstituteCheck = false;
      this.startupData.get('sInstituteInput').clearValidators();
    }

  }

  sProgramChange() {
    var value = this.startupData.get('sProgram').value;
    if (value.Program_Name == "Other") {
      this.sProgramCheck = true;
      this.startupData.get('sProgramInput').addValidators(Validators.required);
    }
    else {
      this.sProgramCheck = false;
      this.startupData.get('sProgramInput').clearValidators();
    }

  }

  changeType(str) {
    var fund = document.getElementById("fund")
    var boot = document.getElementById("boot")
    var active = document.getElementById("active")
    if (str == 'Current Student') {
      boot.style.color = 'black'
      fund.style.color = 'white'
      active.style.right = '122px'
      this.startupData.patchValue({ fundOrBoot: true })
    }
    else if (str == 'Alumni') {
      boot.style.color = 'white'
      fund.style.color = 'black'
      active.style.right = '2px'
      this.startupData.patchValue({ fundOrBoot: false })
    }
    console.log(this.startupData.value.fundOrBoot)
  }



  // ======================= functions to change section ================================
  next() {
    if (this.activeSection == 1) {
      document.getElementById('two').classList.replace('inactive', 'active');

      document.getElementById('dot-con').style.backgroundColor = 'white';
      setTimeout(() => {
        document.getElementById('dot-con').style.backgroundColor =
          'transparent';
        document.getElementById('one').classList.replace('active', 'inactive');
      }, 500);
    }
    if (this.activeSection == 2) {
      return 0;
    }
    this.activeSection += 1;
  }

  previous() {
    if (this.activeSection == 2) {
      document.getElementById('one').classList.replace('inactive', 'active');

      document.getElementById('dot-con').style.backgroundColor = 'white';
      setTimeout(() => {
        document.getElementById('dot-con').style.backgroundColor =
          'transparent';
        document.getElementById('two').classList.replace('active', 'inactive');
      }, 500);
    }
    if (this.activeSection == 1) {
      return 0;
    }
    this.activeSection -= 1;
  }
  // ======================= functions to change section ================================

  /* function to upload pitch deck */
  pitchUpload(file) {
    let non_pdf = document.getElementById('non-uploaded').offsetWidth;

    if (file[0].size > 5242880) {
      // alert("File is too big! Max size allowed is 5MB");
      this.snackbar.open('File is too big! Max size allowed is 5MB.', 'OK');
      return 0;
    }

    this.pitchBlob = file[0];
    this.pitchExtension = this.pitchBlob.name.split('.').pop();
    let allowedExt = ['pdf', 'pptx', 'ppt'];
    if (!allowedExt.includes(this.pitchExtension)) {
      // this.snackbar.open("Please upload a .pdf,.pptx,.ppt file only.", "OK");
      this.pitchBase64 = '../../assets/upload/Error_upload.svg';
      return;
    }

    this.pitchKeyName = uuid.v4() + '.' + this.pitchExtension;
    this.pitchChanged = true;
    if (this.pitchExtension == 'pdf')
      this.pitchBase64 = '../../assets/pdfIco.png';
    else this.pitchBase64 = '../../assets/docx.png';
    setTimeout(() => {
      document.getElementById('pdf').style.margin = `6px ${(non_pdf - 50) / 2
        }px`;
    }, 50);
  }

  startupStorage = new StartupModel();

  checkFileUploads() {
    if (this.pitchKeyName == undefined || this.pitchKeyName == null) {
      return false;
    }
    return true;
  }

  problemStatementWarn = false;
  ideaPitchWarn = false;


  /* SUBMIT FORM FUNCTION */
  submit() {
    this.progressSpinner = true;
    console.log(this.startupData.valid);
    if (!this.startupData.valid) {
      document.getElementById('snack').classList.add('appear');
      this.message = 'Please Enter All Required Details !';

      this.problemStatementWarn = true;
      this.ideaPitchWarn = true;

      setTimeout(() => {
        document.getElementById('snack').classList.remove('appear');
      }, 500);
      this.progressSpinner = false;
      return 0;
    }
    // else if (!this.checkFileUploads()) {
    //   document.getElementById('snack').classList.add('appear');
    //   this.message = 'Upload Pitch Deck First !';
    //   setTimeout(() => {
    //     document.getElementById('snack').classList.remove('appear');
    //   }, 500);
    //   this.progressSpinner = false;
    //   return 0;
    // }

    console.log(this.startupData.value);

    this.startupStorage.Applab_id = uuid.v4();

    this.startupStorage.Applab_FirstName = this.startupData.value.sFname;
    this.startupStorage.Applab_LastName = this.startupData.value.sLname;
    this.startupStorage.Applab_Email = this.startupData.value.sEmail;
    this.startupStorage.Applab_Contact = this.startupData.value.sMobile;
    if (this.sUniversityCheck) {
      this.startupStorage.Applab_UniversityName = this.startupData.value.sUniversityInput;
      if (this.startupData.value.sUniversityInput != null && this.startupData.value.sUniversityInput != "" && !this.university.includes(this.startupData.value.sUniversityInput)) {
        this._rdsServer.postUni({ Uni_id: uuid.v4(), Uni_Name: this.startupData.value.sUniversityInput }).subscribe((res) => {
          console.log(res);
        })
      }
    }
    else {
      this.startupStorage.Applab_UniversityName = this.startupData.value.sUniversity.Uni_Name;
    }

    if (this.sInstituteCheck) {
      this.startupStorage.Applab_InstituteName = this.startupData.value.sInstituteInput;
      if (this.startupData.value.sInstituteInput != null && this.startupData.value.sInstituteInput != "" && !this.institute.includes(this.startupData.value.sInstituteInput)) {
        this._rdsServer.postIns({ Institute_id: uuid.v4(), Institute_Name: this.startupData.value.sInstituteInput }).subscribe((res) => {
          console.log(res);
        })
      }
    }
    else {
      this.startupStorage.Applab_InstituteName = this.startupData.value.sInstitute.Institute_Name;
    }

    if (this.sProgramCheck) {
      this.startupStorage.Applab_ProgramName = this.startupData.value.sProgramInput;
      if (this.startupData.value.sProgramInput != null && this.startupData.value.sProgramInput != "" && !this.institute.includes(this.startupData.value.sProgramInput)) {
        this._rdsServer.postProg({ Program_id: uuid.v4(), Program_Name: this.startupData.value.sProgramInput }).subscribe((res) => {
          console.log(res);
        })
      }
    }
    else {
      this.startupStorage.Applab_ProgramName = this.startupData.value.sProgram.Program_Name;
    }

    if (this.startupData.value.fundOrBoot) {
      this.startupStorage.Applab_Student_Alumni = 'Current Student'
    }
    else {
      this.startupStorage.Applab_Student_Alumni = 'Alumni';
    }

    // if(this.isMobile){
    //   this.startupStorage.Applab_DeviceType = 'Mobile'
    // }
    // else{
    //   this.startupStorage.Applab_DeviceType = 'Desktop'
    // }

    this.startupStorage.Applab_DeviceType = 'B-Plan';

    this.startupStorage.Applab_StartupName = this.startupData.value.sName;
    this.startupStorage.Applab_ProblemStatement = this.startupData.value.sProblemStatement;
    this.startupStorage.Applab_IdeaPitch = this.startupData.value.sIdeaPitch;
    this.startupStorage.Applab_BPlan = this.pitchKeyName;

    this._rdsServer
      .getStartupLogoImageUrl(this.logoKeyName, this.logoExtension)
      .subscribe((resLogo) => {
        console.log(resLogo);
        this._rdsServer
          .getStartupPitchImageUrl(this.pitchKeyName, this.pitchExtension)
          .subscribe((resPitch) => {
            console.log(resPitch);
            this.imageUploadService
              .uploadImage(
                resLogo['ImageUrl'],
                this.logoExtension,
                this.logoBlob
              )
              .subscribe((resLogoUplad) => {
                console.log(resLogoUplad);
                this.imageUploadService
                  .uploadImage(
                    resPitch['ImageUrl'],
                    this.pitchExtension,
                    this.pitchBlob
                  )
                  .subscribe((resPitchUpload) => {
                    console.log(resPitchUpload);
                    this._rdsServer
                      .postStartupForm(this.startupStorage)
                      .subscribe((res) => {
                        document.getElementById('snack').classList.add('appear-slide');
                        this.progressSpinner = false;
                        this.message = '';
                        this.submitted = true;
                      });
                  });
              });
          });
      });
  }

  message = '';
  textCount = 0;
  textCount2 = 0

  changeCharCount(str) {
    this.textCount = str.length;
  }
  changeCharCount2(str) {
    this.textCount2 = str.length;
  }

  mouseEnter(id) {
    document.getElementById(id).style.opacity = '1';
    document.getElementById(id).style.display = 'block';
  }
  mouseLeave(id) {
    document.getElementById(id).style.opacity = '0';
    document.getElementById(id).style.display = 'none';
  }

  show() {
    this.showOptions = !this.showOptions;
  }
}
